export default __webpack_public_path__ + "static/gradient-b438166c6b0993b3d766d8fd38a865ba.jpg";